import React from 'react'
import { Subscriber } from 'react-broadcast'

const Company = ({ render }) => (
  <Subscriber channel="company">{render}</Subscriber>
)

export default Company



// WEBPACK FOOTER //
// ./src/components/Company/index.js